import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Destination } from 'src/app/models/destination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { DestinationService } from 'src/app/services/destination.service';

@Component({
  selector: 'app-destination-list-group',
  templateUrl: './destination-list-group.component.html',
  styleUrls: ['./destination-list-group.component.scss']
})
export class DestinationListGroupComponent implements OnInit, OnChanges {
  @Output() destinationEvent = new EventEmitter<Destination>();
  @Input() saving!: number;
  destinations: Destination[] = [];
  destinationSelected: Destination = null;
  destinationSelectedId: number = null;
  pagination = {
    total: [],
    filter: [],
    pageSize: 10,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  filterWord: string = null;
  editDestination: { [key: number]: boolean } = {};
  loading = false;

  constructor(private destinationService: DestinationService,
    private toastService: ToastrService) { }

  ngOnInit(): void {
    this.getDestinations();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['saving']) {
      this.getDestinations();
    }
  }

  getDestinations() {
    this.loading = true;
    this.destinationService.getDestinationsActive(true).subscribe({
      next: (response: ResponseObject) => {
        this.destinations = response.data;
        this.pagination.filter = this.destinations;
        this.pagination.total = this.destinations;
        this.resetPagination();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener destinos.", "Error");
        this.loading = false
      }
    });
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  setDestinationSelected(destination: Destination) {
    this.destinationSelected = destination;
    this.destinationSelectedId = this.destinationSelected.id;
    this.destinationEvent.emit(this.destinationSelected);
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWord = value;
    this.searching();
  }

  searching() {
    this.pagination.total = this.destinations.filter((list) => {
      const filter = this.filterWord.toLowerCase();

      return (
        list.name.toLowerCase().includes(filter) // búsqueda parcial por nombre
      );
    });

    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  updateList(destination: Destination) {
    this.destinationService.updateDestination(destination.id, { name: destination.name }).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Destino actualizado correctamente.", "Exito");
        this.editDestination[destination.id] = false;
        this.getDestinations();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se actualizo el nombre del destino", "Error");
      }
    });
  }

  deleteList(destination: Destination) {
    this.destinationService.deleteDestination(destination.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Lista eliminada correctamente.", "Exito");
        this.getDestinations();
        this.destinationSelected = null;
        this.destinationSelectedId = null;
        this.destinationEvent.emit(null);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pudo elimino la lista", "Error");
      }
    });
  }

  editingName(destination: Destination) {
    if (this.editDestination[destination.id]) {
      this.editDestination[destination.id] = false;
      return;
    }
    this.editDestination[destination.id] = true;
  }
}
